"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks/shared";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { UserTasksApi } from "@/openapi/generated";

export function useUserTaskGet(
  taskId: string | null | undefined,
  options?: { enabled?: boolean },
) {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();
  const id = taskId?.trim() ?? "";
  const enabled = (options?.enabled ?? true) && id.length > 0;

  return useQuery({
    queryKey: [QueryKeys.UserTasks, "detail", tenantId, id],
    enabled:
      enabled && !!accessToken && tenantId != null && tenantId > 0,
    queryFn: async () => {
      const token = accessToken;
      const tid = tenantId;
      if (!token || tid == null) {
        throw new Error("Missing session or tenant for task");
      }
      const service = createAuthenticatedApi(UserTasksApi, token);
      return service.apiUserTasksIdGet({ id, xTenantID: tid });
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
